<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="height: 100%">
            <el-header>
                <el-form :model="searchData" :inline="true" class="demo-form-inline" style="margin-top: 10px">
                    <el-form-item label="日期">
                        <el-date-picker
                            v-model="dataTime"
                            type="daterange"
                            align="right"
                            size="small"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @change="onDatePickerChange"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" class="btn-primary" @click="handleSearch">查找</el-button>
                        <el-button size="small" type="warning" @click="pullDingTalkRecord">拉取钉钉考勤数据</el-button>
                        <span style="color: grey">（ ※ 每天凌晨会自动拉取前一天的考勤数据，如需要今日考勤数据，请选择今天日期后手动拉取）</span>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-container style="height: 100%">
                <el-aside width="20%">
                    <el-card shadow="never" style="padding: 25px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree
                            ref="tree"
                            node-key="Id"
                            check-strictly
                            highlight-current
                            lazy
                            :props="treeProps"
                            :filter-node-method="filterNode"
                            :load="loadNode"
                            :default-expanded-keys="defaultexpanded"
                            :render-content="renderContent"
                            @node-click="handleNodeClick"
                        ></el-tree>
                    </el-card>
                </el-aside>
                <el-main width="80%" style="padding: 0px 20px 0px 20px; margin: 0px" class="table-ctn">
                    <el-card shadow="never" style="padding: 15px; height: 100%; overflow: auto">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="signRecordsList" border style="width: 100%">
                            <el-table-column prop="SignData" label="日期"></el-table-column>
                            <!-- <el-table-column prop="RecordId" label="考勤编号"></el-table-column> -->
                            <el-table-column prop="StaffName" label="姓名"></el-table-column>
                            <el-table-column prop="SignType" label="打卡方式"></el-table-column>
                            <el-table-column min-width="80px" prop="PicUrl" label="现场照片">
                                <template slot-scope="scope">
                                    <el-image
                                        style="height: 25px"
                                        :src="$util.QN_URL_BASE + scope.row.PicUrl"
                                        fit="scale-down"
                                        :lazy="true"
                                        :preview-src-list="[$util.QN_URL_BASE + scope.row.PicUrl]"
                                        v-if="scope.row.PicUrl"
                                    >
                                        <div slot="error" class="image-slot">
                                            <el-image :src="$util.DEFAULT_IMAGE"></el-image>
                                        </div>
                                    </el-image>
                                    <span v-else>无</span>
                                </template>
                            </el-table-column>
                            <el-table-column width="160" prop="SignTime" label="打卡时间"></el-table-column>
                            <el-table-column prop="DeviceName" label="打卡设备"></el-table-column>
                        </el-table>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataCount"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            entpId: userMsg.EntpId,
            permission: {},
            filterText: '',
            dataTime: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            searchData: {
                entpId: userMsg.EntpId,
                deiviceId: '',
                cascadeId: '',
                startDate: '',
                endDate: '',
                staffId: '',
                page: 1,
                limit: 15
            },
            orgList: [],
            treeProps: {
                children: 'Childrens',
                label: 'Name',
                isLeaf: function (data, node) {
                    //isleaf为true的时候是叶子节点无展开图标
                    return data.StaffCount == 0;
                }
            },
            dataCount: 0,
            signRecordsList: [],
            devicesList: [],
            deiviceId: '',
            defaultexpanded: ['0']
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1, 0);
        this.dataTime.push(date1);
        //前一天设定的日期时间
        let year2, month2, day2;
        // d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date2 = new Date(year2, month2, day2, 0);
        this.dataTime.unshift(date2);

        this.searchData.startDate = date1;
        this.searchData.endDate = date2;
    },
    mounted() {
        this.getDevicesByEntpId();
        this.getSignRecordsList();
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        loadNode(node, resolve) {
            if (node.level == 1) {
                return resolve(this.orgList[0].Childrens);
            }
            let parentId = '';
            if (node.data != null) {
                parentId = node.data.Id;
            }
            this.getSubOrgTree(parentId, node.level, resolve);
        },
        renderContent(h, { node, data, store }) {
            return (
                <span class='custom-tree-node'>
                    <span>
                        {data.Name}
                        {data.Type == 'org' ? '(' + data.StaffCount + ')' : ''}
                    </span>
                </span>
            );
        },
        onDatePickerChange(value) {
            if (value) {
                this.searchData.startDate = value[0];
                this.searchData.endDate = value[1];
            } else {
                this.searchData.startDate = '';
                this.searchData.endDate = '';
            }
        },
        //获取组织树
        getSubOrgTree(parentId, level, resolve) {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetSubOrgTree',
                    data: {
                        entpId: this.entpId,
                        orgId: parentId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.orgList = res.data;
                        if (level == 0) {
                            return resolve(this.orgList);
                        } else if (level == 1) {
                            resolve(this.orgList[0].Childrens);
                        } else {
                            resolve(this.orgList);
                        }
                    }
                })
                .catch(err => {});
        },
        //获取打卡记录
        getSignRecordsList() {
            this.signRecordsList = [];
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetSignRecordsList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.dataCount = res.count;
                        this.signRecordsList = res.data;
                    }
                })
                .catch(err => {});
        },
        //获取设备列表
        getDevicesByEntpId() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetDevicesByEntpId',
                    data: {
                        entpId: this.entpId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.devicesList = res.data;
                    }
                })
                .catch(err => {});
        },
        pullDingTalkRecord() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/PullDingTalkRecords',
                    data: this.searchData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.getSignRecordsList();
                    }
                })
                .catch(err => {});
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            if (data.Type == 'org') {
                this.searchData.cascadeId = data.CascadeId;
                this.searchData.staffId = '';
            } else {
                this.searchData.staffId = data.Id;
                this.searchData.cascadeId = '';
            }
            this.getSignRecordsList();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getSignRecordsList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getSignRecordsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getSignRecordsList();
        }
    }
};
</script>
<style lang="less" scoped></style>
